<template>
    <div class="module">
        <div class="content">
            <IfmSubHeader title="IFM新闻"/>
            <div class="card-list">
                <div v-for="(item, index) in newsObj" :key="index" class="card">
                    <div class="title">{{index|formatTitle}}</div>
                    <img :src="item[0].image">
                    <div class="news-list">
                        <div v-for="(subItem, subindex) in item.slice(0,6)" :key="subindex" class="single" :style="{marginTop:subindex===0?'5px':''}" @click="$router.push(`/detail?id=${subItem.id}`)">
                            <div class="dot"/>
                            <div class="news-content" :title="subItem.title">{{subItem.title}}</div>
                            <div class="time">{{subItem.create_time}}</div>
                        </div>
                    </div>
                </div>

                
            </div>
        </div>
    </div>
</template>
<script>
export default {
    filters:{
        formatTitle(index){
            let val;
            index = Number(index);
            switch (index) {
                case 0:
                    val = '协会通知';
                    break;
                case 1:
                    val = '考试通知';
                    break;
                case 2:
                    val = '培训通知';
                    break;
                case 3:
                    val = '行业新闻';
                    break;
            }
            return val;
        }
    },
    props:{
        newsObj:{
            type: Array,
            default:() => [],
        }
    }
}
</script>
<style lang="scss" scoped>
.module{
    background: #F0F0F0;
    padding: 25px 0 39px 0;
    .content{
        width: 1120px;
        margin: auto;
    }
}
.card-list{
    margin-top: 22px;
    display: flex;
    justify-content: flex-start;
    gap: 30px;
    width: 100%;
    .card{
        width: calc((100% - 60px) / 3);
        min-height: 520px;
        background: #fff;
        .title{
            height:40px;
            line-height: 40px;
            width:100%;
            font-size: 16px;
            padding-left: 21px;
            color: #333333;
            letter-spacing: 0.45px;
            font-weight: 600;
        }
        img{
            width:100%;
            height:130px;
        }
        .news-list{
            box-sizing: border-box;
            padding: 8px 20px 16px 20px;
            .single{
                margin-bottom: 10px;
                cursor: pointer;
                .dot{
                    width: 4px;
                    height: 4px;
                    display: inline-block;
                    background: #333333;
                    vertical-align: middle;
                    border-radius: 50%;
                }
                .news-content{
                    margin-left: 12px;
                    display: inline-block;
                    vertical-align: middle;
                    width: calc(100% - 18px);
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    word-break: break-all;
                }
                .time{
                    font-size: 12px;
                    color: #3B3B3B;
                    letter-spacing: 0.34px;
                    font-weight: 400;
                    margin-top: 5px;
                    padding-left: 16px;
                }
            }
        }
    }
}
</style>
